import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { FirmInstruction } from "../../../../../../../Wrap/Models/Models/Company/FirmInstruction";
import { SectionHeader,TrueFalseRadio } from "../../../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { ContactDetail } from "./ContactDetail";
import { CountryPhone, emptyInstructionPhone } from "./CountryPhone";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { FirmAddress } from "./FirmAddress";
import { FCA } from "./FCA";
import { Branches } from "./Branches";
import { FirmType } from "../../../../../../../Wrap/Constants/Enums/Domain/FirmType";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { ThirdPartyOptions } from "./ThirdPartyOptions";
import { MultiPropositionType } from "../../../../../../../Wrap/Constants/Enums/Domain/MultiPropositionType";
import { FirmCorrespondenceAddress } from "./FirmCorrespondenceAddress";
import { ContactOwnerType } from "../../../../../../../Wrap/Models/Models/Instructions/ContactOwnerType";
import { ThirdPartyBankAccountGroup } from "./ThirdPartyBankAccountGroup";
import { IChildComponentProps } from "../../../../../../../react-core/Html/ChildComponent";
import { NetworkHistoryModel } from "../../../../../../../Wrap/Models/Models/Network/NetworkHistoryModel";
import { CompanyWizardAction } from "../../../Actions/CompanyWizardAction";
import { NetworkType } from "../../../../../../../Wrap/Constants/Enums/Network/NetworkType";
import { CompanyStore } from "../../../Stores/Variable";
import { MultiProductPermissions } from "../../../../../../../Wrap/Constants/Enums/Domain/MultiProductPermissions";
import { CompanyDetail } from "../../../../../../../Wrap/Models/Models/Company/CompanyDetail";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { InstructionPhoneNumber } from "../../../../../../../Wrap/Models/Models/Instructions/InstructionPhoneNumber";
import { InstructionStatus } from "../../../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";

interface IFirmDetailProps extends IChildComponentProps<FirmInstruction> {
    isReview?: boolean;
    onRef: (ref) => void;
}

interface IFirmDetailState {
    currentNetwork: NetworkHistoryModel;
    canEditNetwork: boolean;
    nonWrapEnabledSelected: boolean;
    currentcompany?: CompanyDetail;
}

export class FirmDetail extends FormComponent<IFirmDetailProps, IFirmDetailState> {
    constructor(props: any) {
        super(props);
        this.state = {
            currentNetwork: null,
            canEditNetwork: false,
            nonWrapEnabledSelected: false,
            currentcompany: null,
        };
        this.subscribeToStore(CompanyStore, () => this.onCompanyStoreChange());
    }

    child: Array<any> = [];

    componentDidMount() {
        this.props.onRef(this);
        if (this.props.data.CompanyCode) {
            CompanyWizardAction.getViewCompany(this.props.data.CompanyCode);
        }
        if (this.props.data.Network) {
            this.getNetwork(this.props.data.Network);
        }
        if (this.props.data.MultiProduct?.includes(MultiProductPermissions.SelfInvestedPersonalPension) && this.props.data?.Status === InstructionStatus.Pending) {
            this.props.data.MultiProduct = this.props.data.MultiProduct.filter(
                (p) => p !== MultiProductPermissions.SelfInvestedPersonalPension
            );
        }
        this.props.onRef(this);
    }

    private onCompanyStoreChange() {
        const company = CompanyStore.getSingleData();
        if (company) {
            this.setState({ currentcompany: company });
        }
        if (company?.Network == null) {
            this.setState({ canEditNetwork: true });
        } else {
            this.getNetwork(company?.Network);
        }
    }

    private getNetwork(network: string) {
        const promise = CompanyWizardAction.getNetwork({
            NetworkId: network,
            NetworkType: NetworkType.Network,
            Max: 1,
            Min: 1,
        });
        promise.onSuccess((networks) => {
            this.setState({
                currentNetwork: networks.networks[0],
            });
            this.canEditNetWorkForCompany(networks.networks[0]);
        });
    }

    private canEditNetWorkForCompany(currentNetwork: NetworkHistoryModel) {
        const company = this.state.currentcompany;
        if (CommonHelper.isNullOrEmpty(company)) {return;}
        else {
            if (
                company.FirmType == FirmType.DirectlyAuthorised &&
                !CommonHelper.isNullOrEmpty(currentNetwork.DefaultCompanyId) &&
                company.CompanyId == currentNetwork.DefaultCompanyId
            ) {
                this.setState({ canEditNetwork: false });
            } else {
                this.setState({ canEditNetwork: true });
            }
        }
    }

    isValid(): boolean {
        let flag = true;
        this.child.reverse().forEach((element) => {
            const isValid = element.isValid();
            if (!isValid) {flag = false;}
        });
        return flag;
    }

    private productsPermissionsChange(type: MultiProductPermissions, value: boolean) {
        const { MultiProduct } = this.props.data;
        let _data;
        if (value) {
            _data = MultiProduct.concat(type);
        } else {
            _data = MultiProduct.filter((ele) => ele != type);
        }

        if(_data.includes(MultiProductPermissions.Pension)) {
            _data = _data.filter((ele) => ele != MultiProductPermissions.SelfInvestedPersonalPension);
        }
        
        this.props.onChange({ MultiProduct: _data });
    }

    private renderProductPermission() {
        const { data } = this.props;
        const { MultiProposition } = this.props.data;

        const _options = [ {
            label: "Cash Account",
            value: data.MultiProduct.includes(MultiProductPermissions.PlatformCashAccount),
            onChange: (v) =>
                this.productsPermissionsChange(MultiProductPermissions.PlatformCashAccount, v),
            disabled: this.props.isReview,
        },
        {
            label: "Personal Portfolio",
            value: data.MultiProduct.includes(MultiProductPermissions.PersonalPortfolio),
            onChange: (v) =>
                this.productsPermissionsChange(MultiProductPermissions.PersonalPortfolio, v),
            disabled: this.props.isReview,
        },
        {
            label: "Individual Savings Account (ISA)",
            value: data.MultiProduct.includes(MultiProductPermissions.IndividualSavingsAccount),
            onChange: (v) =>
                this.productsPermissionsChange(
                    MultiProductPermissions.IndividualSavingsAccount,
                    v
                ),
            disabled: this.props.isReview,
        },
        {
            label: "Self-Invested Personal Pension (SIPP)",
            value: data.MultiProduct.includes(MultiProductPermissions.SelfInvestedPersonalPension),
            onChange: (v) =>
                this.productsPermissionsChange(
                    MultiProductPermissions.SelfInvestedPersonalPension,
                    v
                ),
            disabled: this.props.isReview || this.props.data?.MultiProduct?.includes(MultiProductPermissions.Pension),
        },
        {
            label: "Onshore Bond",
            value: data.MultiProduct.includes(MultiProductPermissions.OnshoreBond),
            onChange: (v) =>
                this.productsPermissionsChange(MultiProductPermissions.OnshoreBond, v),
            disabled: this.props.isReview,
        },
        {
            label: "Offshore Bond",
            value: data.MultiProduct.includes(MultiProductPermissions.OffshoreBond),
            onChange: (v) =>
                this.productsPermissionsChange(MultiProductPermissions.OffshoreBond, v),
            disabled: this.props.isReview,
        },
        {
            label: "Aberdeen SIPP",
            value: data.MultiProduct.includes(MultiProductPermissions.Pension),
            onChange: (v) =>
                this.productsPermissionsChange(MultiProductPermissions.Pension, v),
            disabled: this.props.isReview,
        }];

        if (MultiProposition.length === 1 && MultiProposition.find(e => e === MultiPropositionType.Fundzone)) {
            _options.pop();
        }

        return (
            <>
                {SectionHeader("Product permissions")}
                <p>Product wrappers to be permissioned to the adviser group</p>
                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        <CheckboxGroup
                            type="block"
                            options={_options}
                        />
                    </div>
                </div>
                <hr />
            </>
        );
    }

    private onPropostionChange(type: MultiPropositionType, value: boolean) {
        const { MultiProposition } = this.props.data;
        let _data;
        if (value) {
            _data = MultiProposition.concat(type);
        } else {
            _data = MultiProposition.filter((ele) => ele != type);
        }

        //If NonWrapEnabled has been chosen, we don't want any of the other proposition types to be involved.
        if (type == MultiPropositionType.NonWrapEnabled) {
            if (value) {
                this.setState({ nonWrapEnabledSelected: true });
                _data = [].concat(type);
            } else {
                this.setState({ nonWrapEnabledSelected: false });
                _data = [];
            }
        }

        this.props.onChange({ MultiProposition: _data });
    }

    render() {
        const { data } = this.props;
        const createType =
            data.FirmType == FirmType.AppointedRepresentative || data.FirmType == FirmType.DirectlyAuthorised
                ? "adviser"
                : "thirdParty";

        return (
            <>
                <h2>Firm details</h2>
                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        <ContactDetail
                            isReview={this.props.isReview}
                            data={this.props.data}
                            canEditNetwork={this.state.canEditNetwork}
                            currentNetwork={this.state.currentNetwork}
                            onChange={(changes) => this.props.onChange(changes)}
                            onRef={(ref) => this.child.push(ref)}
                            onNetworkSelectionChange={(network) => this.onNetworkSelectionChange(network)}
                        />
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        {SectionHeader("Firm status")}
                        {TrueFalseRadio(
                            "Is Active: ",
                            "IsActive",
                            data,
                            (key, v) => {
                                this.props.onChange({ [key]: v });
                            },
                            true,
                            { disabled: this.props.isReview },
                            "When No is chosen, the selected firm will be unsearchable."
                        )}
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        {SectionHeader("Proposition permission")}
                        <p>Proposition to be permissioned to adviser group</p>
                        <CheckboxGroup
                            type="block"
                            options={[
                                {
                                    label: "Wrap",
                                    value: data.MultiProposition.includes(MultiPropositionType.Wrap),
                                    onChange: (v) => this.onPropostionChange(MultiPropositionType.Wrap, v),
                                    disabled: this.props.isReview || this.state.nonWrapEnabledSelected,
                                },
                                {
                                    label: "Fundzone",
                                    value: data.MultiProposition.includes(MultiPropositionType.Fundzone),
                                    onChange: (v) => this.onPropostionChange(MultiPropositionType.Fundzone, v),
                                    disabled: this.props.isReview || this.state.nonWrapEnabledSelected,
                                },
                                {
                                    label: "Non Wrap Enabled",
                                    value: data.MultiProposition.includes(MultiPropositionType.NonWrapEnabled),
                                    onChange: (v) => this.onPropostionChange(MultiPropositionType.NonWrapEnabled, v),
                                    disabled: this.props.isReview,
                                },
                            ]}
                        />
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        <CountryPhone
                            isReview={this.props.isReview}
                            onChange={(v) => this.props.onChange({ PhoneNumber: v })}
                            sectionHeader="Phone number"
                            required={createType == "adviser"}
                            data={data.PhoneNumber || emptyInstructionPhone}
                            onRef={(ref) => this.child.push(ref)}
                        />
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        <CountryPhone
                            isReview={this.props.isReview}
                            onChange={(v) => this.props.onChange({ FaxNumber: v })}
                            sectionHeader="Fax number"
                            required={this.faxNumberRequiredCheck(data.FaxNumber)}
                            data={data.FaxNumber || emptyInstructionPhone}
                            onRef={(ref) => this.child.push(ref)}
                        />
                        {createType == "thirdParty" && (
                            <>
                                <TextBoxEditor
                                    value={data.ExternalReferenceCode}
                                    required="Please enter External Reference Code"
                                    label="External Reference Code: *"
                                    disabled={this.props.isReview}
                                    maxLength={20}
                                    onChange={(v) => this.props.onChange({ ExternalReferenceCode: v })}
                                />
                                <TextBoxEditor
                                    value={data.WmCode}
                                    label="WM Code:"
                                    maxLength={10}
                                    disabled={this.props.isReview}
                                    onChange={(v) => this.props.onChange({ WmCode: v })}
                                />
                                <SelectEditor
                                    onChange={() => {}}
                                    label="Type of Provider"
                                    options={[data.FirmType]}
                                    selected={data.FirmType}
                                    disabled={true}
                                    getText={() => {
                                        return data.FirmType == FirmType.Bond ? "Bond" : "Pension";
                                    }}
                                />
                            </>
                        )}
                    </div>
                </div>
                <hr />
                {createType == "adviser" && this.renderProductPermission()}
                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        {createType == "thirdParty" ? (
                            <FirmCorrespondenceAddress
                                correspondenceAddress={this.props.data.CompanyAddress}
                                instructionId={this.props.data.Id}
                                isReview={this.props.isReview}
                                onRef={(ref) => this.child.push(ref)}
                                onChange={(v) => this.props.onChange({ CompanyAddress: v })}
                            />
                        ) : (
                            <>
                                <CheckboxGroup
                                    type="block"
                                    options={[
                                        {
                                            label: "Use network address",
                                            value: data.IsUseNetworkAddress,
                                            onChange: (v) => this.onUseNetworkAddressChange(v),
                                            disabled: this.props.isReview,
                                        },
                                    ]}
                                />
                                <FirmAddress
                                    OwnerType={ContactOwnerType.Company}
                                    notRequired={false}
                                    isReview={this.props.isReview}
                                    onRef={(ref) => this.child.push(ref)}
                                    data={data.CompanyAddress?.Address}
                                    instructionId={data.Id}
                                    onChange={(v) => this.props.onChange({ CompanyAddress: { Address: v } })}
                                />
                            </>
                        )}
                    </div>
                </div>
                <hr />
                {createType == "adviser" && (
                    <div className="row">
                        <div className="col-xs-12 col-sm-7">
                            <FCA
                                data={data}
                                isReview={this.props.isReview}
                                taggedNetwork={this.state.currentNetwork !== null}
                                onRef={(ref) => this.child.push(ref)}
                                onChange={(v) => this.props.onChange(v)}
                            />
                        </div>
                    </div>
                )}
                {createType == "adviser" && <hr />}
                {createType == "thirdParty" && (
                    <ThirdPartyOptions
                        data={data}
                        isReview={this.props.isReview}
                        onRef={(ref) => this.child.push(ref)}
                        onChange={(v) => this.props.onChange(v)}
                    />
                )}
                {createType == "thirdParty" && (
                    <ThirdPartyBankAccountGroup
                        bankAccounts={this.props.data.BankAccounts}
                        isReview={this.props.isReview}
                        onChange={(v) => this.props.onChange({ BankAccounts: v })}
                        onRef={(ref) => this.child.push(ref)}
                    />
                )}

                {createType == "thirdParty" && <hr />}
                {createType == "adviser" && (
                    <div className="row">
                        <div className="col-xs-12 col-sm-7">
                            <Branches
                                isReview={this.props.isReview}
                                data={data}
                                onRef={(ref) => this.child.push(ref)}
                                onChange={(v) => this.props.onChange(v)}
                            />
                        </div>
                    </div>
                )}
            </>
        );
    }

    private faxNumberRequiredCheck(faxNumber: InstructionPhoneNumber): boolean {
        if (
            !faxNumber ||
            (faxNumber.AreaCode === null && faxNumber.Country === null && faxNumber.Number === null) ||
            (faxNumber.AreaCode === null && faxNumber.Country === 0 && faxNumber.Number === null)
        ) {
            return false;
        }
        return true;
    }


    private onNetworkSelectionChange(network: NetworkHistoryModel): void {
        this.setState({ currentNetwork: network });
    }

    private onUseNetworkAddressChange(use: boolean): void {
        this.props.onChange({ IsUseNetworkAddress: use });
        if (use) {
            this.props.onChange({
                CompanyAddress: {
                    Address: {
                        InstructionId: this.props.data.Id,
                        Line1: this.state.currentNetwork?.Address?.Line1,
                        Line2: this.state.currentNetwork?.Address?.Line2,
                        Line3: this.state.currentNetwork?.Address?.Line3,
                        Line4: this.state.currentNetwork?.Address?.Line4,
                        Line5: this.state.currentNetwork?.Address?.Line5,
                        PostCode: this.state.currentNetwork?.Address?.Postcode,
                        OwnerType: ContactOwnerType.Company,
                        CountryCode: this.state.currentNetwork?.Address?.CountryCode,
                    },
                },
            });
        }
    }
}
